import * as React from 'react';
import { Redirect } from 'react-router'
import './App.scss';

class App extends React.Component {
  public render() {
    return (
      <div className="App">
        <Redirect to="/dashboard"/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/component/App.tsx